import DeleteConfirmation from './delete-modal'
import InputTypeBasic  from './tm-payout-basic'
import InputTypeDetailed from './tm-payout-detailed'

export default {
  DeleteConfirmation,
  InputTypeBasic,
  InputTypeDetailed
}